import React from 'react'
import CrudManager from './CrudManager'
import schema from './example.json'

const CrudManagerExample = () => {
   
    return (

        <>
        <CrudManager data={schema} />
    {/* //    <CRUDManager schema={schema}/> */} 

        </>
    )
}

export default CrudManagerExample